// progress
import Progress from "../../../components/progress/progress";
// form
import { useForm, FieldErrors, useWatch } from 'react-hook-form';
// make query
import { registerOtp } from "../../../services/auth/otp/registerOtp";
import { useMutation } from "@tanstack/react-query";
// toast
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toastOptions } from "../../../features/toast/toast";
// routes
import { routes } from "../../../features/routes/route";
// navigate
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { StepOtp } from "../../../features/step/stepOtp";
import { IconClock, IconSend } from "@tabler/icons-react";
import { sendOtp } from "../../../services/auth/otp/sendOtp";
// @ts-ignore
import Cookies from 'js-cookie';

const SecondStep = () => {
    const { register, handleSubmit, control, setValue }: any = useForm<any>();
    const [disabled, setDisabled] = useState(false);
    const [timeLeft, setTimeLeft] = useState<number | null>(null);
    const navigate = useNavigate();
    const mutation = useMutation({
        mutationFn: registerOtp,
        onSuccess: data => {
            toast.success('تبریک...', toastOptions)
            navigate(routes.auth[1].address)
        },
        onError: (error: any) => {
            toast.error(error?.response?.data?.message, toastOptions);
        },
    });
    const onSubmit = (data: any) => {
        let newData = data;
        newData.userInputOtp = newData.text[1] + newData.text[2] + newData.text[3] + newData.text[4] + newData.text[5];
        mutation.mutate(newData)
    };
    const onError = (errors: FieldErrors<any>) => {
        toast.error('یکی از فیلدای شماره کارت رو فراموش کردی', toastOptions);
    };

    const otpMutation = useMutation({
        mutationFn: sendOtp,
        onSuccess: data => {
            toast.success('پیامک ارسال شد...', toastOptions)
            window.open(routes.auth[0].address, '_self')
            setDisabled(true);
            timer();
        },
        onError: (error: any) => {
            toast.error(error?.response?.data?.message, toastOptions);
        }
    });

    const timer = () => {
        setDisabled(true);
        setTimeLeft(60);
        const interval = setInterval(() => {
            setTimeLeft((prev) => {
                if (prev !== null && prev > 1) {
                    return prev - 1;
                } else {
                    clearInterval(interval);
                    setDisabled(false);
                    return null;
                }
            });
        }, 1000);
        return () => clearInterval(interval);
    };

    const textValues = useWatch({ control, name: 'text' });

    useEffect(() => {
        if (textValues) {
            // @ts-ignore
            const allFilled = Object.values(textValues).every((value: string) => value.length === 1);
            if (allFilled) {
                const form = document.querySelector('#form-register');
                if (form) {
                    // @ts-ignore
                    form.click();
                }
            }
        }
    }, [textValues]);

    useEffect(() => {
        timer();
    }, [])

    const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
        e.preventDefault();

        const pasteData = e.clipboardData.getData('text').trim();
        const numbers = pasteData.replace(/\D/g, '');
        const limited = numbers.slice(0, 5);

        for (let i = 0; i < limited.length; i++) {
            const input = document.getElementById(`digit${i}`) as HTMLInputElement;
            if (input) {
                input.value = limited[i];
            }
            setValue(`text.${i + 1}`, limited[i]);
        }

        // فوکوس به آخرین خانه
        const lastIndex = limited.length - 1;
        if (lastIndex >= 0) {
            const lastInput = document.getElementById(`digit${lastIndex}`) as HTMLInputElement;
            lastInput?.focus();
        }
    };


    return (
        <>
            <Progress number={0} />
            <section className={'container h-75 pb-3'}>
                <div className={'row h-100 align-items-center justify-content-center'}>
                    <div className={'col-lg-6 overflow-x-hidden col-md-8 col-12 text-center'}>
                        <div className={'px-0 px-5 mb-md-0 mb-4'}>
                            <img alt={'login'}
                                src={require('./../../../assets/media/images/global/Sabtenam_01_Vr_01 1.png')}
                                className={'img-fluid animate_img'} />
                        </div>
                        <form onSubmit={handleSubmit(onSubmit, onError)}>
                            <label className={'form-label text-center text-white mb-3'}>
                                کاربر جدید ایران‌تراکنش، لطفا کدی که برات ارسال کردیم رو در کادر زیر وارد
                                کنین
                            </label>
                            <div
                                style={{ direction: 'ltr' }}
                                className={'row justify-content-center mt-1'}>
                                {Array.from({ length: 5 }).map((_, index) => (
                                    <div key={index + "form"} className="col-2">
                                        <input
                                            type="tel"
                                            onKeyDown={(e) => StepOtp(e, index, `digit`)}
                                            maxLength={1}
                                            id={`digit${index}`}
                                            onPaste={handlePaste}
                                            className="form-control  birthDay step-input code-input ltr text-center step-input"
                                            {...register(`text.${index + 1}`, { required: 'یکی از فیلدای کد رو فراموش کردی' })}
                                        />
                                    </div>
                                ))}
                            </div>
                            <div className="d-flex justify-content-start mt-3">
                                <button
                                    onClick={() => otpMutation.mutate(Cookies.get('mobileNumber'))}
                                    type="button"
                                    className="border-0"
                                    style={{ backgroundColor: 'transparent' }}
                                    disabled={disabled}
                                >
                                    <span className="mt-3 font-medium-lg px-5">
                                        {timeLeft !== null ? <IconClock size={14} className="ms-2" /> : <IconSend size={14} className="ms-2" />}
                                        <span className="ms-1">یک دقیقه تا</span>
                                        <span className="ms-1">
                                            {timeLeft !== null ? ' ارسال دوباره' : 'ارسال دوباره'}
                                        </span>
                                    </span>
                                </button>
                            </div>
                            <div className={'d-flex justify-content-end mt-3'}>
                                <button
                                    type={'submit'}
                                    id={'form-register'}
                                    className={'btn form-btn fw-bold rounded rounded-pill p-2 px-4'}>
                                    {mutation.isPending ? (<>
                                        در حال ارسال
                                    </>) : 'ادامه'}
                                    {mutation.isPending ? (<>
                                        <span className="spinner-border spinner-border-sm ms-2"></span>
                                    </>) : (
                                        <>
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M12.7801 6.31005C15.6501 4.66005 18.0001 6.01005 18.0001 9.33005V12V14.67C18.0001 17.98 15.6501 19.34 12.7801 17.68L10.4701 16.34L8.16007 15C5.29007 13.34 5.29007 10.63 8.16007 8.97005"
                                                    stroke="#171717" strokeWidth="2" strokeMiterlimit="10"
                                                    strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </>
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
            <ToastContainer />
        </>
    )
}

export default SecondStep;
